import { render, staticRenderFns } from "./assestView.vue?vue&type=template&id=4bc382b6&scoped=true"
import script from "./assestView.vue?vue&type=script&lang=js"
export * from "./assestView.vue?vue&type=script&lang=js"
import style0 from "./assestView.vue?vue&type=style&index=0&id=4bc382b6&prod&lang=scss&scoped=true"
import style1 from "./assestView.vue?vue&type=style&index=1&id=4bc382b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc382b6",
  null
  
)

export default component.exports